// ------------------------------------
// Produtos (Carrosel)
// ------------------------------------

const produtosCarrosselClass = '.carousel-prods';

catalogoInitSlick();

// Desabilita o plugin de carrosel
function catalogoDestroySlick() {
  const $produtosCarrossel = $(produtosCarrosselClass);
  $produtosCarrossel.each(function () {
    const $carroselItem = $(this);
    if ($carroselItem.hasClass('slick-slider')) {
      $carroselItem.slick('unslick');
    }
  });
}

// Aplica o plugin de carrosel
function catalogoInitSlick() {
  const $produtosCarrossel = $(produtosCarrosselClass);
  $produtosCarrossel.each(function () {
    const $carroselItem = $(this);
    if (!$carroselItem.hasClass('slick-initialized')) {
      $carroselItem.slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        autoplay: false,
        adaptiveHeight: false,
        dots: false,
        // Responsivo
        responsive: [
          // Tablet
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          // Mobile
          {
            breakpoint: 480,
            settings: 'unslick',
          },
        ],
      });
    }
  });
  setTimeout(() => {
    catalogoFixBlHeight();
  }, 100);
}

// Ajusta a altura dos blocos com base no maior
function catalogoFixBlHeight() {
  const $produtosCarrossel = $(produtosCarrosselClass);
  if ($produtosCarrossel.length > 0) {
    $produtosCarrossel.each(function () {
      const $carrossel = $(this);
      let maxHeight = 0;
      $carrossel.find('.prod-bl').css('height', 'auto');
      setTimeout(() => {
        $carrossel.find('.prod-bl').each(function () {
          const prodHeight = $(this).outerHeight();
          if (prodHeight > maxHeight) {
            maxHeight = prodHeight;
          }
        });
        $carrossel.find('.prod-bl').css('height', maxHeight);
      }, 100);
    });
  }
}
catalogoFixBlHeight();
$(window).on(
  'resize',
  debounce(function () {
    catalogoFixBlHeight();
  }, 100),
);

if (!previewMode) {
  slickReinitLazy($(produtosCarrosselClass), catalogoInitSlick, catalogoDestroySlick);
}
